"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var returnInfoTabs = function () {
    var buttons = document.querySelectorAll('.pageReturnsInfo__button');
    var tabs = document.querySelectorAll('.pageReturnsInfo__tab');
    if (!buttons || !tabs)
        return;
    buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            var target = e.currentTarget;
            var dataTarget = target.getAttribute('data-tab');
            if (!dataTarget)
                return;
            buttons.forEach(function (btn) {
                btn.classList.remove('pageReturnsInfo__button--active');
            });
            tabs.forEach(function (tab) {
                tab.classList.remove('pageReturnsInfo__tab--active');
            });
            target.classList.add('pageReturnsInfo__button--active');
            var activeTab = document.querySelector(".pageReturnsInfo__tab[data-tab=\"" + dataTarget + "\"]");
            if (activeTab) {
                activeTab.classList.add('pageReturnsInfo__tab--active');
            }
        });
    });
};
exports.default = returnInfoTabs;
